import { formatISO, parse } from 'date-fns';

export const formatBirthdate = (birthdate?: number | string) => {
  if (!birthdate) return;

  const stringifiedBirthdate = birthdate.toString();
  return formatISO(parse(stringifiedBirthdate, 'MMddyyyy', new Date()), {
    representation: 'date',
  });
};
